import DelayAPI from './delay.api'

export default DelayAPI
